import { useCallback, useRef, useState } from 'react';
import type { BrtaOutcome, OwnerNav, OwnerScreen, OwnerVehicleType, VehicleDraft } from '../types/owner';

const ROOTS: OwnerScreen[] = ['splash', 'onboarding', 'login', 'register', 'home'];

export const draftSamples: Record<OwnerVehicleType, VehicleDraft> = {
  cng: {
    type: 'cng',
    category: 'সিএনজি অটোরিকশা',
    reg: 'ঢাকা-থ-১১-১২৩৪',
    regDate: '১২/০১/২০২২',
    brand: 'বাজাজ',
    model: 'RE 4S',
    year: '২০২১',
    color: 'সবুজ',
    chassis: 'MDH12F45ABC123456',
    engine: 'ENG987654321',
    fuel: 'CNG',
    ownership: 'একক মালিকানা'
  },
  motorcycle: {
    type: 'motorcycle',
    category: 'মোটরসাইকেল',
    reg: 'ঢাকা মেট্রো-ল-৪৫-৬৭৮৯',
    regDate: '০৮/০৩/২০২৩',
    brand: 'Yamaha',
    model: 'FZS V3',
    year: '২০২৩',
    color: 'কালো',
    chassis: 'ME1RG1234K0005678',
    engine: 'G3J3E0098765',
    fuel: 'পেট্রোল',
    ownership: 'একক মালিকানা'
  }
};

export function useOwnerNav(initial: OwnerScreen = 'splash'): OwnerNav {
  const [stack, setStack] = useState<OwnerScreen[]>([initial]);
  const [vehicleId, setVehicleId] = useState('c1');
  const [draft, setDraft] = useState<VehicleDraft>(draftSamples.cng);
  const [brtaOutcome, setBrtaOutcome] = useState<BrtaOutcome>('matched');
  const [otpPurpose, setOtpPurpose] = useState<'register' | 'reset' | 'login'>('register');
  const [detailTab, setDetailTab] = useState('info');
  const [focusAppId, setFocusAppId] = useState('DMP-OWN-2026-000117');
  const [correctionPrefill, setCorrectionPrefill] = useState('');
  const [toast, setToast] = useState<string | null>(null);
  const timer = useRef<number | undefined>(undefined);

  const go = useCallback((s: OwnerScreen) => setStack((st) => [...st, s]), []);
  const back = useCallback(() => setStack((st) => (st.length > 1 ? st.slice(0, -1) : st)), []);
  const reset = useCallback((s: OwnerScreen) => setStack(ROOTS.includes(s) ? [s] : ['home', s]), []);
  const startDraft = useCallback((t: OwnerVehicleType) => setDraft(draftSamples[t]), []);

  const showToast = useCallback((msg: string) => {
    setToast(msg);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setToast(null), 2400);
  }, []);

  return {
    screen: stack[stack.length - 1],
    go,
    back,
    reset,
    vehicleId,
    setVehicleId,
    draft,
    startDraft,
    setDraft,
    brtaOutcome,
    setBrtaOutcome,
    otpPurpose,
    setOtpPurpose,
    detailTab,
    setDetailTab,
    focusAppId,
    setFocusAppId,
    correctionPrefill,
    setCorrectionPrefill,
    toast,
    showToast
  };
}
